/* converts abc_xyz to Abc Xyz */
export const formatFunnelStatus = (status) =>
  status
    .split('_')
    .map((word) => word.slice(0, 1).toUpperCase() + word.slice(1))
    .join(' ');
